export default "__VITE_ASSET__CbYyH6kD__"